// TODO use these STYLES when switching to v3
// replace S12345 with DEFAULT
export const STYLES = {
  DEFAULT: 'default',
  S12345: 's12345',
  S12334: 's12334',
  S12234: 's12234',
  S23456: 's23456',
  SINGLE: 'single',
  TILES_VERTICAL: 'tiles-vertical',
  TILES_GAIA_PLUS: 'tiles-gaia-plus',
  TILES_TOP_TEN: 'tiles-top-ten',
  TILES_TOP_TEN_VERTICAL: 'tiles-top-ten-vertical',
}

export const NULL_CLIENT_OFFSET = { x: 0, y: 0 }

/**
 * Retrieves the client X offset from a touch event or regular mouse event.
 *
 * @param {Event} e - The touch or mouse event object.
 * @returns {number} The client offset, defaulting to 0 if undefined.
 */
export function getClientOffset (e) {
  const offset = { ...NULL_CLIENT_OFFSET }
  if (e.touches && e.touches.length > 0) {
    offset.x = e.touches[0].clientX || 0
    offset.y = e.touches[0].clientY || 0
  } else {
    offset.x = e.clientX || 0
    offset.y = e.clientY || 0
  }
  return offset
}

/**
 * Get the container width of a container element.
 *
 * @param {Element} element - The element to measure.
 * @returns {number} The calculated width, rounded to two decimal places.
 */
export function getContainerWidth (element) {
  // Get exact width value with decimals
  const { width } = element.getBoundingClientRect()
  // Round to biggest decimal place for precision
  return Math.ceil(width * 100) / 100
}

/**
 * Calculates the anchors for slides based on their widths.
 *
 * @param {Array} slideRefs - Array of refs to slide elements.
 * @returns {Array} - Array of objects representing the start, end, width, and index of each anchor.
 */
export function calculateAnchors (slideRefs = []) {
  return slideRefs.reduce((acc, ref, i) => {
    if (ref && ref.current) {
      const { width } = ref.current.getBoundingClientRect()
      const roundedWidth = Math.floor(width * 100) / 100
      const start = i === 0 ? 0 : acc[i - 1].end
      const end = start + roundedWidth
      acc.push({
        start,
        end,
        width: roundedWidth,
        index: i,
      })
    }
    return acc
  }, [])
}

/**
 * @function getVisibleIndexes
 * @param {Object} index - An object containing left and right indices.
 * @param {Array} slides - The array of slides to calculate visible indexes for.
 * @returns {Array} - An array of visible slide indexes.
 */
export function getVisibleIndexes (index, slides) {
  return Array(index.right - index.left + 1)
    .fill(index.left)
    .map((_, i) => (index.left + i) % slides.length)
}
